import { challengePoints, serviceSteps } from '../content'
import { Icon } from './Icon'

function ChallengeGraphic() {
  return (
    <svg
      className="untangle reveal"
      viewBox="0 0 760 360"
      aria-label="A tangled set of lines becoming one clear route"
      role="img"
    >
      <path
        className="mess"
        d="M20 99C157 17 114 297 250 149S378 22 426 162 304 289 196 226 234 55 345 76s103 172 4 190S177 180 278 111s164 111 66 155"
      />
      <path
        className="mess"
        d="M21 146c98-40 169-52 220 2 63 66 120-120 195-58 71 60-40 148-126 119-88-29-113-87-56-135"
      />
      <path
        className="mess"
        d="M29 210c115 83 183-63 271-8 74 47 111 10 156-50"
      />
      <path className="clear" d="M420 164C522 164 608 164 720 164" />
      <path
        d="m704 148 16 16-16 16"
        fill="none"
        stroke="var(--blue)"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="420" cy="164" r="13" fill="#ff6853" />
    </svg>
  )
}

export function ChallengeSolution() {
  return (
    <>
      <section
        className="section section--dark"
        id="why-ark"
        aria-labelledby="challenge-title"
      >
        <div className="container problem-grid">
          <div className="reveal">
            <p className="section-number">01 / The challenge</p>
            <h2 className="section-title" id="challenge-title">
              The talent gap is real. Your standards don’t have to move.
            </h2>
            <p className="section-copy">
              Finding and keeping qualified finance professionals is harder than
              ever. Firms face constant pressure from:
            </p>
            <ul className="problem-list">
              {challengePoints.map((point) => (
                <li key={point}>{point}</li>
              ))}
            </ul>
          </div>
          <ChallengeGraphic />
        </div>
      </section>

      <section className="section" aria-labelledby="solution-title">
        <div className="container solution-layout">
          <div className="reveal">
            <p className="section-number">02 / The solution</p>
            <h2 className="section-title" id="solution-title">
              Add capacity without adding complexity.
            </h2>
            <p className="section-copy">
              Ark Solutions sources, employs and supports qualified South African
              professionals who integrate into your team, tools and working
              rhythm—without the operational burden of setting up locally.
            </p>
          </div>
          <div className="route reveal" aria-label="Ark Solutions service route">
            {serviceSteps.map((step) => (
              <article className="route-step" key={step.title}>
                <span className="icon-ring" aria-hidden="true">
                  <Icon name={step.icon} />
                </span>
                <h3>{step.title}</h3>
                <p>{step.description}</p>
              </article>
            ))}
          </div>
        </div>
      </section>
    </>
  )
}
